


















































import { ref, defineComponent, watchEffect } from "@vue/composition-api";
import { useModelWrapper } from "@/service/base/modelWrapper";
export default defineComponent({
  name: "doubleConfirm",
  components: {},
  props: {
    btnLabel: {
      require: true,
      type: String,
    },
    contentLabel: {
      require: true,
      type: String,
    },
    tooltipLabel: {
      require: false,
      type: String,
      default: "",
    },
    loading: {
      require: false,
      type: Boolean,
      default: false,
    },
    disabled: {
      require: false,
      type: Boolean,
      default: false,
    },
    value: {
      required: false,
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const dialog = ref(false);
    const btnClickRes = useModelWrapper(props, emit, "value");
    function clickAgree() {
      btnClickRes.value = true;
    }
    function clickDisAgree() {
      btnClickRes.value = false;
    }
    return {
      dialog,
      props,
      btnClickRes,
      clickAgree,
      clickDisAgree,
    };
  },
});
